define(function pageareaStateModule() {
  'use strict';

  var state = function state() {
    var NAMESPACE = 'pagearea';
    var ALIAS = 'pagearea';

    var mutations = {
      init: function init() {
        var state = {
          page: [],
          previousState: {},
          nextState: {}
        };
        return state;
      },
      setView: function setView(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          page: _payload
        });
      },
      setPreviousState: function setPreviousState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          previousState: JSON.parse(JSON.stringify(_payload))
        });
      },
      setNextState: function setNextState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          nextState: JSON.parse(JSON.stringify(_payload))
        });
      }
    };

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations
    };
  };

  return state;
});
